var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[(_vm.place.website)?_c('a',{attrs:{"href":_vm.place.website,"target":"_blank"}},[_vm._v(_vm._s(_vm.place.name))]):_c('span',[_vm._v(_vm._s(_vm.place.name))])]),_vm._v(" "),_c('p',{staticClass:"address"},[_vm._v(_vm._s(_vm.place.formatted_address))])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e7113f2c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Place.vue
// module id = null
// module chunks = 